// import AOS from 'aos';

// Innehåller alla skrolleffekter och liknande

export function initAnimations() {
    let options = {
        rootMargin: '80px 0px 80px 0px',
    };
    if(window.screen.width < 450) {
        options = {
            threshold: [0.00, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1.0],
            rootMargin: '80px 0px 80px 0px',
        }
    }
    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.intersectionRatio > 0) {
                entry.target.classList.add('scroll-effect-visible');
            }
        });
    }, options);

    const elems = document.querySelectorAll('[data-aos]');
    if(elems.length > 0) {
        elems.forEach(ele => observer.observe(ele));
    }
}
